import styled, { css } from "styled-components";

import { BillboardHighlightsContentContainer } from "pages/[tenant]/console/billboard/components/BillboardHighlightsContent/styles";
import { BillboardPageContainer } from "pages/[tenant]/console/billboard/components/BillboardPage/styles";
import { BillboardSectionFormContainer } from "pages/[tenant]/console/billboard/components/BillboardSectionForm/styles";

interface IBillboardContainerProps {
  isInConsolePage?: boolean;
}

export const BillboardContainer = styled.div<IBillboardContainerProps>`
  background-color: ${({ theme }) => theme.groups.backgroundModeration};
  display: grid;
  height: calc(100% - 4rem);

  ${({ isInConsolePage }) =>
    isInConsolePage
      ? css`
          ${BillboardPageContainer}, ${BillboardSectionFormContainer}, ${BillboardHighlightsContentContainer} {
            max-width: 76.25rem; // 1220px
          }
        `
      : css`
          margin-top: 4rem;

          ${BillboardPageContainer}, ${BillboardSectionFormContainer}, ${BillboardHighlightsContentContainer} {
            @media screen and (min-width: 1100px) {
              width: calc(100% - 20rem);
              margin-left: 20rem;
            }
          }
        `}

  > .loader {
    width: fit-content;
    height: fit-content;
    margin: 3rem auto;
    place-self: center;
  }
`;
